import OmsSolutions, { OmsSolutionsProps } from "@/components/omsSolutions";

const WhyOneMind = (props: OmsSolutionsProps) => {
  return <OmsSolutions {...props} />;
};

export default WhyOneMind;
